import isEmpty from 'lodash/isEmpty';

import { bulkReasignUser } from 'common/api/v1/contacts';
import { showReponseErrorsAsAlert } from 'common/utils/helpers';
import showToast from 'common/utils/showToast';

import {
    BULK_UPDATE_ITEMS,
    BULK_UPDATE_ITEMS_FAILURE,
    BULK_UPDATE_ITEMS_SUCCESS,
} from '../actionTypes';
import { contactActions } from '../reducer';

import filterContacts from './filterContacts';
import openReasignModal from './openReasignModal';

export default (filterData, values) => (dispatch) => {
    dispatch(contactActions[BULK_UPDATE_ITEMS]());

    const users = [
        {
            contacts: values.contacts,
            id: values.user,
        },
    ];

    bulkReasignUser({ users })
        .then((response) => {
            dispatch(contactActions[BULK_UPDATE_ITEMS_SUCCESS](response.data));
            if (!isEmpty(filterData)) dispatch(filterContacts(filterData));
            showToast();
            if (values?.callback) values?.callback();
            dispatch(openReasignModal(false));
        })
        .catch((error) => {
            dispatch(
                contactActions[BULK_UPDATE_ITEMS_FAILURE](
                    error?.response?.data?.errors,
                ),
            );
            showReponseErrorsAsAlert(dispatch, error?.response);
        });
};
